export default __webpack_public_path__ + "static/media/top-partners-background.c764731e.svg";